import { render, staticRenderFns } from "./ReportFormation.vue?vue&type=template&id=26644e70&scoped=true&"
import script from "./ReportFormation.vue?vue&type=script&lang=js&"
export * from "./ReportFormation.vue?vue&type=script&lang=js&"
import style0 from "./ReportFormation.vue?vue&type=style&index=0&id=26644e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26644e70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
